import React from 'react';
import LazyLoad from 'react-lazyload';
import { buildPdpProductArrayForPush, pushExternalLinkItem, pushNewEcommerceEvent } from "../../utils/datalayer";
import { getDomainFromHref } from "../../utils";

class ImageDescCTA extends React.Component {

	handleClick(e) {
		const { modelNumber, product, listPrice, fromList } = this.props;
		const url = `/product/${modelNumber}`;

		// console.log(url);

		const items = [{
			item_name: product.name || product.title,
			item_id: product.id || undefined,
			item_brand: 'Sentry Safe',
			item_category: undefined,
			item_category2: undefined,
			item_list_name: fromList,
			item_variant: undefined,
			coupon: undefined,
			discount: undefined,
			'quantity': 1,
			price: listPrice || undefined,
		}]

		pushNewEcommerceEvent('select_item', items);

		window.location = url;
	}

	render() {
		const { imgSrc, title, modelNumber, saleFlag, product, listPrice } = this.props;
		const url = `product/${modelNumber}`;
		return (
			<li>
				<div className="product-card-box">
					<a className="product-img" href={url} onClick={(e) => this.handleClick(e)}>
						<LazyLoad once={true} offset={200}>
							<img src={imgSrc} alt="" />
						</LazyLoad>
					</a>
					<h3 className="product-title" onClick={(e) => this.handleClick(e)}>
						{title}
					</h3>
					<span className="product-model" onClick={(e) => this.handleClick(e)}>
						Model {modelNumber}
					</span>
					<div data-bv-show="inline_rating" data-bv-product-id={modelNumber}></div>
				</div>
			</li>
		);
	};
}

export default ImageDescCTA;


// WEBPACK FOOTER //
// ./src/pages/common/ProductImageCTA.js